<template>
    <button class="btn-close"
            v-clipboard:copy="filterURL()"
            v-clipboard:success="showCopySuccess"
            :disabled="disabled">
        <i class="fa fa-clipboard"></i>
    </button>
</template>

<script>
  import Storage from '../../api/Storage'
  import Helper from '../../api/Helper'

  export default {
    name: 'CopyButton',
    props: {
      disabled: {
        type: Boolean,
        required: true
      }
    },
    methods: {
      showCopySuccess () {
        this.$notify({
          type: 'success',
          text: this.$t('filters.filter_copied'),
          animationType: 'velocity'
        })
      },
      filterURL () {
        if (!Storage.selectedCountry) {
          return null
        }
        const location = window.location.href.replace('/?.+/')
        const offerId = Helper.getOffersList()
        const operatorsList = Helper.getOperatorsList()
        const dateRange = Helper.getDateRange()
        const courierId = Helper.getCouriersList()
        return `${location}?country_id=${Helper.getCountryList()}${offerId ? '&offer_id=' + offerId : ''}${operatorsList ? '&operator_id=' + operatorsList : ''}${dateRange}${courierId ? '&courier_id=' + courierId : ''}`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CopyButton.vue?5fa57ffa